export const officialList = '/cgm/cmsContent/getOfficialList'
export const expertInstitution = '/cgm/glpOfficialIndex/expertInstitution'
export const getExpectLoseWeight = '/cgm/glpIndex/getExpectLoseWeight'//测一测减重多少
export const cmsContent = '/cgm/cmsContent/detail'